<script setup lang="ts">
    import { computed, toRef } from 'vue'

    import type { AlternativeEditorAttributeFieldReadModel } from '@Alternatives/Alternatives/Domain/readmodels'
    import type { ValidationError } from '@common/types'

    // ---------------- props ----------------

    const props = defineProps<{
        propF: AlternativeEditorAttributeFieldReadModel
        propErrors: ValidationError[]
    }>()

    // ---------------- shortcuts ----------------

    const f = toRef(props, 'propF')
    const errors = toRef(props, 'propErrors')

    // ---------------- computed ----------------

    const error = computed(() =>
        errors.value?.find(e =>
            e.Context.startsWith(`AlternativeAttribute:${f.value.Id}`)
        )?.Error
    )

    const tooltipText = computed(() =>
    {
        let tooltip = 'Please enter text'
        if (f.value.IsRequired) tooltip += ', required'
        if (f.value.MinLength) tooltip += `, minimum length: ${f.value.MinLength}`
        if (f.value.MaxLength) tooltip += `, maximum length: ${f.value.MaxLength}`
        return tooltip
    })
</script>


<template>
    <div class="form-group">
        <label>
            <span v-if="f.IsRequired" style="color: red;">*</span> {{f.Name}}
        </label>

        <input type="text" class="form-control" placeholder="Enter text..." :title="tooltipText"
               v-model.trim="f.Value"
               :required="f.IsRequired === true"
               :readonly="f.IsReadonly === true"
               :minlength="f.MinLength != null ? f.MinLength : null"
               :maxlength="f.MaxLength != null ? f.MaxLength : null" />

        <div class="error">{{error}}</div>
        <small class="form-text text-muted" v-if="f.Description">{{f.Description}}</small>
    </div>
</template>